import { activeFbSignupSourceForPixel } from "@/lib/landing-source";

const CURRENCY = "USD";
const META_PIXEL_ID = "182393662588232";

const PRODUCTION_PIXEL_HOSTS = new Set([
  "realpranks.com",
  "www.realpranks.com",
  "rosscreations.com",
  "www.rosscreations.com",
]);

type MetaPixelParams = Record<string, string | number | boolean | undefined>;

/** Pixel events are production-only. Test/preview hosts are blocked in Events Manager. */
export function shouldLoadMetaPixel(
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
): boolean {
  return PRODUCTION_PIXEL_HOSTS.has(hostname.toLowerCase());
}

/** Inline path → FB landing for the first PageView in HTML snippets. */
const SNIPPET_PAGE_VIEW_CATEGORY = `
var _rcPv={};
var _rcP=(location.pathname.split('?')[0].split('#')[0].toLowerCase().replace(/\\/+$/, '')||'/');
if(_rcP==='/fb1')_rcPv.content_category='fb1';
else if(_rcP==='/fb2')_rcPv.content_category='fb2';
else if(_rcP==='/fb3')_rcPv.content_category='fb3';
else if(_rcP==='/fb4')_rcPv.content_category='fb4';
if(_rcPv.content_category)fbq('track','PageView',_rcPv);
else fbq('track','PageView');
`.trim();

export function getMetaPixelSnippet(): string {
  return `(function(){
var host=location.hostname.toLowerCase();
if(host!=='realpranks.com'&&host!=='www.realpranks.com'&&host!=='rosscreations.com'&&host!=='www.rosscreations.com')return;
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
${SNIPPET_PAGE_VIEW_CATEGORY}
})();`;
}

function withLandingCategory(params?: MetaPixelParams): MetaPixelParams | undefined {
  const category = activeFbSignupSourceForPixel();
  if (!category && !params) return undefined;
  if (!category) return params;
  return { content_category: category, ...params };
}

function track(event: string, params?: MetaPixelParams): void {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  if (!shouldLoadMetaPixel()) return;

  const payload = withLandingCategory(params);
  if (payload) {
    window.fbq("track", event, payload);
  } else {
    window.fbq("track", event);
  }
}

export function trackPageView(): void {
  track("PageView");
}

export function trackViewContent(params?: MetaPixelParams): void {
  track("ViewContent", { currency: CURRENCY, ...params });
}

export function trackInitiateCheckout(params: MetaPixelParams & { value: number }): void {
  track("InitiateCheckout", { currency: CURRENCY, ...params });
}

export function trackMembershipPurchase(params: MetaPixelParams & { value: number }): void {
  const payload = { currency: CURRENCY, ...params };
  track("Purchase", payload);
  track("Subscribe", payload);
}
